import * as actionTypes from '../types/adminActs';

const initialState = {
  actsList: [],
  actsGet: {
    okRequest: false,
    loading: false
  },
  actsSign: {
    okRequest: false,
    loading: false
  }
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.GET_ACTS:
      return {
        ...state,
        actsGet: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.GET_ACTS_SUCCESS:
      return {
        ...state,
        actsList: payload,
        actsGet: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.GET_ACTS_FAIL:
      return {
        ...state,
        actsGet: {
          okRequest: false,
          loading: false
        }
      };

    case actionTypes.SIGN_ACTS:
      return {
        ...state,
        actsSign: {
          okRequest: false,
          loading: true
        }
      };

    case actionTypes.SIGN_ACTS_SUCCESS:
      return {
        ...state,
        actsSign: {
          okRequest: true,
          loading: false
        }
      };

    case actionTypes.SIGN_ACTS_FAIL:
      return {
        ...state,
        actsSign: {
          okRequest: false,
          loading: false
        }
      };
    default:
      return state;
  }
};

export default reducer;
